<!--正式授权-->
<template>
  <div class="container">
    <div class="marginCon">
      <span class="labelTitle">认证身份：</span>
      <span class="grayCont">{{rzsf}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">试用期限：</span>
      <span class="grayCont">{{yxstart_time}} - {{yxend_time}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">试用项目数量：</span>
      <span class="grayCont">{{MaxProjectCount}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">正式授权状态：</span>
      <span class="blueState">{{stateText}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">已等待时长：</span>
      <span class="grayCont">{{durationHour}}</span>
    </div>

    <div class="revokeCon">
      <a class="revokeBtn" @click="undoApply">{{revokeBtnTxt}}</a>
      <span class="revokeTip">撤销后可编辑认证资料</span>
    </div>

    <p class="lineStyle"></p>
    <div class="marginCon">
      <span class="labelTitle">社会信用代码：</span>
      <span class="grayCont">{{nsrsbh}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">企业名称：</span>
      <span class="grayCont">{{qymc}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">资质等级：</span>
      <span class="grayCont">{{zzdj}}</span>
    </div>

    <div class="fileOutCon">
      <span class="fileTitle">营业执照副本：</span>
      <div class="fileCon businessCon">
        <div class="viewer" v-viewer="{}">
          <MultiImage
            v-for="(item,index) in businessFiles"
            :loading="false"
            :key="index"
            :index="index"
            :src="item.path"
            :original-src="item.path"
            :del-btn="false"
          >
          </MultiImage>
        </div>
      </div>
    </div>

    <div class="marginCon" v-if="sqlx == 1">
      <span class="labelTitle">与协同软件签订的合同编号：</span>
      <span class="grayCont">{{htbh}}</span>
    </div>

    <div class="fileOutCon" v-if="sqlx == 1">
      <span class="fileTitle">与协同软件签订的合同附件：</span>
      <div class="fileCon contractCon">
        <div class="viewer" v-viewer="{}">
          <MultiImage
            v-for="(item,index) in contractFiles"
            :loading="false"
            :key="index"
            :index="index"
            :src="item.path"
            :original-src="item.path"
            :del-btn="false"
          >
          </MultiImage>
        </div>
      </div>
    </div>

    <!--撤销申请弹窗-->
    <el-dialog
      title="提示"
      width="460px"
      :visible.sync="undoDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="undoDialogCon">
        <p class="ud-content">是否撤销正式授权申请？</p>

        <a class="ud-btn-ok" @click="undoDialogOkClick">确认</a>
        <a class="ud-btn-no" @click="undoDialogNoClick">取消</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MultiImage from '@/components/MultiImage'

  export default {
    name: 'Authorize'
    , data () {
      return {
        businessFiles: []
        , contractFiles: []
        // 认证guid
        , rz_guid: ''
        // 认证身份
        , rzsf: '-'
        // 使用项目数量
        , MaxProjectCount: '-'
        // 申请类型
        , sqlx: 0
        // 认证状态
        , stateText: '-'
        // 认证申请日期
        , yxstart_time: ''
        // 认证通过日期
        , yxend_time: ''
        // 等待时长
        , durationHour: '-'
        // 撤销申请按钮文字
        , revokeBtnTxt: '-'
        // 社会信用代码
        , nsrsbh: '-'
        // 企业名称
        , qymc: '-'
        // 资质等级
        , zzdj: '-'
        // 合同编号
        , htbh: '-'
        // 撤销申请弹窗显示
        , undoDialogVisible: false
      }
    }
    , props: {
      common: {
        type: Object
      }
    }
    , components: {
      MultiImage
    }
    , methods: {
      // 初始化页面数据
      initViewData (result, resultbg) {
        // 认证guid
        this.rz_guid = result.rz_guid
        // 申请类型
        this.sqlx = result.sqlx
        // 认证状态
        if (result.sqlx == '0') { // 产品试用
          this.stateText = '产品试用审核中'
          this.revokeBtnTxt = '撤销产品试用申请'
        } else { // 正式授权
          this.stateText = '正式授权审核中'
          this.revokeBtnTxt = '撤销正式授权申请'
        }
        // 认证身份
        this.rzsf = result.rzsf
        // 试用期限
        this.yxstart_time = result.yxstart_time
        this.yxend_time = result.yxend_time
        // 使用项目数量
        this.MaxProjectCount = result.MaxProjectCount
        // 等待时长
        this.durationHour = result.durationhour + '小时'
        // 社会信用代码
        this.nsrsbh = result.nsrsbh
        // 企业名称
        this.qymc = result.qymc
        // 资质等级
        this.zzdj = result.zzdj
        // 合同编号
        this.htbh = result.htbh
        // 附件过滤
        for (let i = 0; i < resultbg.length; i++) {
          var item = resultbg[i]
          if (item.leixing == 0) {
            this.businessFiles.push(item)
          } else if (item.leixing == 1) {
            this.contractFiles.push(item)
          }
        }
      }
      // 获取格式化时间
      , getFormatDate (str) {
        let date = new Date(str)
        return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDay() + '日'
          + date.getHours() + '时' + date.getMinutes() + '分' + date.getSeconds() + '秒'
      }

      // 撤销正式授权申请 => 试用用户
      , undoApply: function () {
        this.undoDialogVisible = true
      }
      // 撤销弹窗确定点击
      , undoDialogOkClick () {
        // 因为本就是产品试用进行的正式授权申请

        let params = {
          rz_guid: this.rz_guid
          , zt: 2 // 改为通过后的试用用户身份
          , sqlx: '0' // 状态改为试用用户
          , rzsf: '' // 认证身份改为空, 只有试用进行正式授权申请才有该字段
        }
        this.$axios.post('UserManager/SetRzSf', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'False') {
              this.$message({
                message: '撤销正式授权申请成功!'
                , type: 'success'
              })
              // 调用父级请求状态方法!
              this.common.getDataCallback()
            } else if (data.isError == 'True') {
              this.$message({
                message: data.errorMessage
                , type: 'warning'
              })
            }
            this.undoDialogVisible = false
          })
          .catch((err) => {
            this.$message({
              message: '撤销申请失败,请刷新重试!'
              , type: 'warning'
            })
            this.undoDialogVisible = false
          })
      }
      // 撤销弹窗取消点击
      , undoDialogNoClick () {
        this.undoDialogVisible = false
      }

    }
    , created () {
      this.initViewData(this.common.result, this.common.resultbg)
    }
  }
</script>

<style scoped>
  p, div, input {
    overflow: hidden;
    transition: all .3s;
  }

  .marginCon {
    height: 19px !important;
    line-height: 19px !important;
    margin-top: 24px;
    padding: 0px !important;
  }

  .blueState {
    margin-left: 20px;
    font-size: 18px;
    color: #3492FF;
    font-weight: 600;
  }

  .grayCont {
    margin-left: 20px;
    font-size: 14px;
    color: #7F7F7F;
  }

  .lineStyle {
    width: 800px;
    height: 1px;
    background: #EDEDED;
    margin: 32px auto;
  }

  .revokeCon {
    margin-top: 24px;
  }

  .revokeBtn {
    display: inline-block;
    width: 180px;
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    margin-left: 434px;
    background: #FFFFFF;
    border: 1px solid #5BA7FF;
    border-radius: 4px;
    font-size: 14px;
    color: #3492FF;
    text-align: center;
  }

  .revokeTip {
    margin-left: 24px;
    font-size: 12px;
    color: #5C5C5C;
    letter-spacing: 0.88px;
  }

  .fileOutCon {
    font-size: 14px;
    color: #000;
    margin-top: 24px;
  }

  .fileTitle {
    display: inline-block;
    width: 417px;
    vertical-align: top;
    text-align: right;
  }

  .businessCon {

  }

  .fileCon {
    margin-left: 20px;
  }

  /*取消授权弹窗 begin*/
  .undoDialogCon {
    height: 228px;
    text-align: center;
    font-size: 0;
  }

  .ud-content {
    margin-top: 60px;
    margin-bottom: 58px;
    font-size: 16px;
    color: #5C5C5C;
    letter-spacing: 1.18px;
    font-weight: 600;
  }

  .undoDialogCon a {
    display: inline-block;
    box-sizing: border-box;
    width: 100px;
    height: 36px;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0;
    border-radius: 4px;
    font-weight: 600;
  }

  .ud-btn-ok {
    border: 1px solid #3492FF;
    color: #3492FF;
  }

  .ud-btn-no {
    background: #5F93FF;
    border: 1px solid #3492FF;
    color: #FFFFFF;
    margin-left: 24px;
  }

  /*取消授权弹窗 end*/
</style>



// WEBPACK FOOTER //
// src/page/Authorize.vue